'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableCaption", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-caption;
    &:not([data-show]) {
      position: absolute;
      height: 1px;
      width: 1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
    }
  `
});
const TableCaption = ({ children, show = false }) => {
  return react.jsx("caption", { css: Styles.root, "data-show": show ? "" : void 0, "data-zds": true }, children);
};

exports.TableCaption = TableCaption;
//# sourceMappingURL=TableCaption.cjs.js.map
